<aside
  *ngIf="isVisible"
  id="car-sidebar"
  class="car-sidebar"
  [class.car-sidebar--collapsed]="collapsed"
  aria-label="Menu principal">
  <header
    class="car-sidebar__header"
    [class.car-sidebar__header--collapsed]="collapsed">
    <ng-container *ngIf="!collapsed; else collapsedBrand">
      <div class="car-sidebar__brand">
        <b3-logo
          size="md"
          safe-area=""
          color="primary"
          show-label="">
          Balcão
        </b3-logo>
      </div>

      <b3-tooltip
        class="car-sidebar__tooltip"
        label="Recolher menu"
        variant="single-line"
        pointer="left">
        <button
          type="button"
          class="car-sidebar__collapse-btn"
          aria-label="Recolher menu"
          (click)="toggleCollapsed()">
          <b3-icon name="left_panel_close" size="sm" tone="neutral"></b3-icon>
        </button>
      </b3-tooltip>
    </ng-container>

    <ng-template #collapsedBrand>
      <b3-tooltip
        class="car-sidebar__tooltip"
        label="Expandir menu"
        variant="single-line"
        pointer="left">
        <button
          type="button"
          class="car-sidebar__brand car-sidebar__brand--collapsed-toggle"
          aria-label="Expandir menu"
          (click)="toggleCollapsed()">
          <b3-logo
            class="car-sidebar__brand-logo"
            size="sm"
            color="primary"
            aria-hidden="true">
          </b3-logo>
          <b3-icon
            class="car-sidebar__brand-open-icon"
            name="left_panel_open"
            size="sm"
            tone="neutral"
            aria-hidden="true">
          </b3-icon>
        </button>
      </b3-tooltip>
    </ng-template>
  </header>

  <nav class="car-sidebar__nav" *ngIf="sidebarNav as nav" aria-label="Navegação principal">
    <b3-menu-vertical aria-label="Menu de navegação lateral" background="grey">
      <b3-menu-vertical-item
        icon="home"
        [variant]="menuItemVariant"
        [attr.variant]="menuItemVariant"
        [label]="itemLabel('Página inicial')"
        [attr.aria-label]="collapsed ? 'Página inicial' : null"
        [selected]="isHomeActive()"
        (b3-click)="navigateTo(nav.home.link, $event)">
      </b3-menu-vertical-item>

      <b3-menu-vertical-item
        *ngFor="let group of nav.groups; trackBy: trackGroup"
        [icon]="group.icon"
        [variant]="menuItemVariant"
        [attr.variant]="menuItemVariant"
        [label]="itemLabel(group.label)"
        [attr.aria-label]="collapsed ? group.label : null"
        [expanded]="!labelsCollapsed && isGroupExpanded(group)"
        [selected]="isGroupActive(group)"
        (b3-click)="onGroupItemClick(group, $event)">
        <ng-container *ngIf="!labelsCollapsed">
          <ng-container *ngFor="let child of group.children; trackBy: trackChild">
            <b3-menu-vertical-sub-item
              *ngIf="child.type === 'section'"
              class="car-sidebar__section-label"
              [class.car-sidebar__sub-item--fading]="collapsed"
              [label]="child.label">
            </b3-menu-vertical-sub-item>

            <b3-menu-vertical-sub-item
              *ngIf="child.type === 'link'"
              [class.car-sidebar__sub-item--fading]="collapsed"
              [label]="child.label"
              [selected]="isLinkActive(child.link)"
              (b3-click)="navigateTo(child.link, $event)">
            </b3-menu-vertical-sub-item>

            <b3-menu-vertical-sub-item
              *ngIf="child.type === 'external'"
              [class.car-sidebar__sub-item--fading]="collapsed"
              [label]="child.label"
              [href]="child.url"
              [target]="child.target ?? '_blank'"
              (b3-click)="onExternalClick($event)">
            </b3-menu-vertical-sub-item>
          </ng-container>
        </ng-container>
      </b3-menu-vertical-item>

      <b3-menu-vertical-item
        *ngFor="let item of footerItems; trackBy: trackFooter; let first = first"
        [icon]="item.icon"
        [variant]="menuItemVariant"
        [attr.variant]="menuItemVariant"
        [label]="itemLabel(item.label)"
        [attr.aria-label]="collapsed ? item.label : null"
        [class.car-sidebar__utility-item--first]="first"
        (b3-click)="onFooterAction(item)">
      </b3-menu-vertical-item>
    </b3-menu-vertical>
  </nav>
</aside>

<b3-drawer
  class="car-sidebar__support-drawer"
  [open]="supportDrawerOpen"
  placement="right"
  size="md"
  overlay
  (b3-close)="closeSupportDrawer()"
  (b3-back)="closeSupportDrawer()"
  (b3-request-close)="closeSupportDrawer()"
  (b3-request-back)="closeSupportDrawer()">
  <b3-drawer-header
    heading="Ajuda e suporte"
    show-back
    back-aria-label="Fechar ajuda e suporte">
  </b3-drawer-header>

  <b3-drawer-body>
    <div class="support-drawer" aria-label="Perguntas frequentes de ajuda e suporte">
      <section
        class="support-drawer__section"
        *ngFor="let section of supportSections; trackBy: trackSupportSection">
        <h3 class="support-drawer__section-title">{{ section.title }}</h3>

        <div class="support-drawer__items">
          <article
            class="support-drawer__item"
            *ngFor="let item of section.items; trackBy: trackSupportFaqItem">
            <h4 class="support-drawer__item-heading">
              <button
                type="button"
                class="support-drawer__item-trigger"
                [attr.id]="'support-faq-trigger-' + item.id"
                [attr.aria-expanded]="isFaqExpanded(item.id)"
                [attr.aria-controls]="'support-faq-panel-' + item.id"
                [attr.aria-label]="item.number + '. ' + item.question"
                (click)="toggleFaqItem(item.id)">
                <span class="support-drawer__item-number" aria-hidden="true">{{ item.number }}.</span>
                <span class="support-drawer__item-question">{{ item.question }}</span>
                <b3-icon
                  class="support-drawer__item-chevron"
                  [name]="isFaqExpanded(item.id) ? 'keyboard_arrow_up' : 'keyboard_arrow_down'"
                  size="sm"
                  tone="neutral"
                  aria-hidden="true">
                </b3-icon>
              </button>
            </h4>

            <div
              class="support-drawer__item-panel"
              *ngIf="isFaqExpanded(item.id)"
              [attr.id]="'support-faq-panel-' + item.id"
              role="region"
              [attr.aria-labelledby]="'support-faq-trigger-' + item.id">
              <app-support-faq-answer [blocks]="item.answer"></app-support-faq-answer>
            </div>
          </article>
        </div>
      </section>

      <a
        class="support-drawer__help-link"
        [href]="supportUrl"
        target="_blank"
        rel="noopener noreferrer">
        Ainda precisa de ajuda?
        <b3-icon name="open_in_new" size="sm" tone="default" aria-hidden="true"></b3-icon>
      </a>
    </div>
  </b3-drawer-body>
</b3-drawer>
